import { HttpError } from "@/store/core/HttpError";
import { AxiosError } from "axios";
/**
 *
 * @param err
 */
export function axiosExceptionToHttpError(err: AxiosError) {
  return new HttpError(err.message, parseInt(err.code || "500"), err.stack);
}
